import './qrIndex.css';
import React, { useState, useEffect, useCallback } from 'react';
import {
  FaSortDown,
  FaPlus,
  FaExternalLinkAlt,
} from 'react-icons/fa';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import { Box } from '@mui/material';
import { customBaseUrl, httpGet } from '../../store/http';
import GeneratedQr from './generatedQrModal';
import { Progress } from 'antd';
import ExportQr from './exportQr';
import GenQR from './genQR';
import { hideLoader, showLoader } from '../../utils/loader';
import Swal from 'sweetalert2';

const Search = ({ getAll, setOpenExport }) => {
  const [openGenerateModal, setOpenGenerateModal] = useState(false);
  const [count, setCount] = useState("");
  const [showProgress, setShowProgress] = useState(false);
  const [prog, setProg] = useState(0);

  const handleGenerate = useCallback(async () => {
    if (!count) return Swal.fire('Oops', 'Count field is empty')
    setOpenGenerateModal(false)
    setShowProgress(true);
    showLoader();
    let response = await httpGet(`${customBaseUrl.qrCodeUrl}/api/v1/qrcode/generateQRCode/count/${count}`)
    if (response.status) {
      hideLoader();
      Swal.fire('Success', response?.message);
      setShowProgress(false);
      setCount('');
      getAll();
    } else {
      hideLoader();
    }
  }, [count, getAll]);

  useEffect(() => {
    const interval = setInterval(() => {
      setProg(50 + Math.floor(Math.random() * 50))
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section>
      <div className="search-wrapper">
        <div className="container">
          <div className="mechanics">
            <div className="mechanics-icon" onClick={() => setOpenExport(true)}>
              <div className="icon">
                <FaExternalLinkAlt />
              </div>
              <div className="export-data ">Export QR CODE</div>
            </div>
            <div onClick={() => { setOpenGenerateModal(true) }} style={{ cursor: 'pointer' }} className="mechanics-icon">
              <div className="icon">
                <FaPlus />
              </div>
              <div className="generate-code">
                Generate QR Code
              </div>
            </div>
            <>
              <br />
              {showProgress && <Progress percent={prog} showInfo={false} />}
            </>
          </div>
        </div>
      </div>
      {openGenerateModal && (
        <GenQR
          setCount={setCount}
          count={count}
          handleGenerate={handleGenerate}
          showModal={openGenerateModal}
          hideModal={() => setOpenGenerateModal(false)}
        />
      )}
    </section>
  );
};

const ManageQR = ({ setShowManageQR }) => {
  const [state, setState] = useState([]);
  const [assigned, setAssigned] = useState(0);
  const [unassigned, setUnassigned] = useState(0);
  const [qrData, setQrData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openExport, setOpenExport] = useState(false);
  const [totalQRGen, setTotalQRGen] = useState(0);
  const [selectedRow, setSelectedRow] = useState({});
  const [pagination, setPagination] = useState({ current: 0, pageSize: 20 });
  const [totalQr, setTotalQr] = useState(0);
  const [totalExported, setTotalExported] = useState(0);
  const [adminUsers, setAdminUsers] = useState([]);

  const getAll = useCallback(async (page, size) => {
    showLoader();
    const pages = page ?? pagination.current;
    const limit = size ?? pagination.pageSize;
    const res = await httpGet(
      `${customBaseUrl.qrCodeUrl}/api/v1/qrcode/find/all?page=${pages}&size=${limit}`
    );
    if (res?.status !== 401 && res?.status !== false) {
      setState(res?.qrcodeList || []);
      setTotalQr(res?.totalItems || 0)
    }
    hideLoader();
  }, [pagination.current, pagination.pageSize]);

  const getAdmin = useCallback(async () => {
    showLoader();
    const res = await httpGet(
      `${customBaseUrl.authUrl}/api/v1/admin/users-admin-users?page=0&size=100`
    );
    if (res?._embedded?.userResponse) {
      setAdminUsers(res?._embedded?.userResponse);
    }
    hideLoader();
  }, []);

  const fetchData = useCallback(async () => {
    const responseTG = await httpGet(`${customBaseUrl.qrCodeUrl}/api/v1/qrcode/get-total-count`);
    if (responseTG?.status !== 401 && responseTG?.status !== false) {
      setTotalQRGen(responseTG);
    }
    const assignedQr = await httpGet(`${customBaseUrl.qrCodeUrl}/api/v1/qrcode/get-assigned-count`);
    if (assignedQr?.status !== 401 && assignedQr?.status !== false) {
      setAssigned(assignedQr);
    }
    const unassignedQr = await httpGet(`${customBaseUrl.qrCodeUrl}/api/v1/qrcode/get-unassigned-count`);
    if (unassignedQr?.status !== 401 && unassignedQr?.status !== false) {
      setUnassigned(unassignedQr);
    }
    const exported = await httpGet(`${customBaseUrl.qrCodeUrl}/api/v1/qrcode/get-total-exported`);
    if (exported?.status !== 401 && exported?.status !== false) {
      setTotalExported(exported);
    }
    getAll();
  }, [getAll]);

  useEffect(() => {
    // getAdmin();
    fetchData();
  }, [getAdmin, fetchData]);

  const renderDetailsButton = (params) => {
    const handleModal = (qrValue, row) => {
      setOpenModal(true);
      setQrData(qrValue);
      setSelectedRow(row);
    };
    return (
      <strong>
        <Button
          key={params?.row?.action?.id}
          variant="contained"
          size="small"
          style={{
            width: '120px',
            backgroundColor: '#FFF1EC',
            border: '1px solid #FF4B01',
            color: '#FF4B01',
          }}
          onClick={() => {
            handleModal(params?.row?.qrCode, params?.row?.action)
          }}
        >
          View QR Code
        </Button>
      </strong>
    );
  };

  const columns = [
    {
      field: 'id',
      headerName: 'QR ID',
      headerClassName: 'super-app-theme--header',
      width: 100,
    },
    {
      field: 'assigned',
      headerName: 'QR ASSIGNMENT STATUS',
      headerClassName: 'super-app-theme--header',
      width: 200,
      renderCell: ({ row }) =>
        <span
          style={{
            color: `${row.assigned ? "#27AE60" : "#EB5757"}`,
          }}
        >
          {row.assigned ? 'ASSIGNED' : 'UNASSIGNED'}
        </span>
    },
    {
      field: 'exported',
      headerName: 'EXPORTED STATUS',
      headerClassName: 'super-app-theme--header',
      width: 200,
      renderCell: ({ row }) =>
        <span
          style={{
            color: `${row.exported ? "#27AE60" : "#EB5757"}`,
          }}
        >
          {row.exported ? 'EXPORTED' : 'NOT EXPORTED'}
        </span>
    },
    {
      field: 'fullName',
      headerName: 'MERCHANT NAME',
      headerClassName: 'super-app-theme--header',
      width: 200,
      renderCell: ({ row }) => row?.fullName ?? 'N/A'
    },
    {
      field: 'createdAt',
      headerName: 'DATE CREATED',
      headerClassName: 'super-app-theme--header',
      width: 120,
    },
    {
      field: 'action',
      headerName: 'ACTION',
      headerClassName: 'super-app-theme--header',
      width: 160,
      renderCell: renderDetailsButton,
      disableClickEventBubbling: true,
    },
  ];

  const handleChangeRowsPerPage = async (value) => {
    setPagination({ ...pagination, current: 0, pageSize: value });
    await getAll(0, value);
  };

  const handleChangePage = async (newPage) => {
    setPagination({ ...pagination, current: newPage });
    await getAll(newPage, pagination.pageSize);
  };

  const modalCloseAction = () => {
    setOpenModal(false);
  }

  return (
    <>
      <div className="App">
        <div>
          <Button
            size="medium"
            style={{ background: "#FF4B01", fontSize: "10px", color: "#fff" }}
            onClick={() => setShowManageQR(true)}
          >
            Manage QR code
          </Button>
          <Button
            onClick={() => setShowManageQR(false)}
            size="medium"
            style={{ background: "#fff", margin: "10px", fontSize: "10px", color: "#000" }}
          >
            Manage Field Marketer
          </Button>
        </div>
        <div>
          <Search setOpenExport={setOpenExport} getAll={getAll} />
          <div className="cards-container">
            <div className="cards">
              <p>Total Generated QR Codes</p>
              <h2>{totalQRGen}</h2>
            </div>
            <div className="cards">
              <p>Total Exported QR Codes</p>
              <h2>{totalExported}</h2>
            </div>
            <div className="cards">
              <p>Total Assigned QR Codes</p>
              <h2>{assigned}</h2>
            </div>
            <div className="cards">
              <p>Total Unassigned QR Codes</p>
              <h2>{unassigned}</h2>
            </div>
          </div>
        </div>
        <Box
          sx={{
            width: 1,
            '& .super-app-theme--header': {
              background: '#ff6700',
              color: '#ffffff',
            },
          }}
        >
          <div
            style={{
              height: 650,
              width: '100%',
              background: '#fff',
              borderRadius: '8px',
            }}
          >
            {state.length > 0 && <DataGrid
              rows={state}
              columns={columns}
              rowHeight={125}
              page={pagination.current}
              paginationMode="server"
              pageSize={pagination.pageSize}
              onPageSizeChange={(newPageSize) =>
                handleChangeRowsPerPage(newPageSize)
              }
              onPageChange={(newPage) => handleChangePage(newPage)}
              rowsPerPageOptions={[5, 10, 20, 50, 100]}
              pagination
              components={{ Toolbar: GridToolbar }}
              rowCount={totalQr}
            />}
          </div>
        </Box>
      </div>
      {openModal && <GeneratedQr modalState={openModal} modalCloseAction={modalCloseAction} qrValue={qrData} selectedRow={selectedRow} />}
      {
        openExport &&
        <ExportQr
          showModal={openExport}
          hideModal={setOpenExport}
          adminUsers={adminUsers}
        />
      }
    </>
  );
}

export default ManageQR;
